import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CommentsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 34,
  height = 34,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-1077.000000, -799.000000)">
          <g transform="translate(1077.000000, 523.000000)">
            <g transform="translate(17.293750, 291.000000) scale(-1, 1) translate(-17.293750, -291.000000) translate(0.793750, 276.000000)">
              <path
                d="M29.21625,0.999988164 C29.7114675,0.999988164 30.1595151,1.20246263 30.4839474,1.52893669 C30.8106439,1.85768932 31.0121791,2.31200266 31.0121791,2.81351351 L31.0121791,2.81351351 L31.0121791,19.4594595 C31.0121791,19.9398794 30.8226535,20.4008253 30.4844816,20.7401433 C30.1486657,21.0770974 29.6935332,21.2662487 29.21625,21.2648649 L29.21625,21.2648649 L16.6193084,21.2648649 L10.5629774,27.3189256 L10.095049,21.2648649 L2.78787162,21.2648649 C2.3143839,21.2648649 1.86057263,21.075103 1.52586862,20.738294 C1.18882043,20.399126 0.999988238,19.938976 0.999988238,19.4594595 L0.999988238,19.4594595 L0.999984098,2.79442012 C0.998611596,2.31739153 1.18583319,1.85922205 1.52113694,1.52180946 C1.85408202,1.1867704 2.30590139,0.998611665 2.77981419,0.999988164 L2.77981419,0.999988164 Z"
                stroke="#000000"
                className={styles.defaultStrokeColor}
                strokeWidth="2"
              />
              <ellipse
                cx="8.08966216"
                cy="11.5297297"
                fill="#0050B3"
                className={styles.interactiveColor}
                fillRule="nonzero"
                rx="2.3608277"
                ry="2.37567568"
              />
              <ellipse
                cx="16.0020608"
                cy="11.5297297"
                fill="#0050B3"
                className={styles.interactiveColor}
                fillRule="nonzero"
                rx="2.3608277"
                ry="2.37567568"
              />
              <ellipse
                cx="24.1722973"
                cy="11.5297297"
                fill="#0050B3"
                className={styles.interactiveColor}
                fillRule="nonzero"
                rx="2.3608277"
                ry="2.37567568"
              />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
